module.exports = __webpack_public_path__ + "img/faq-gri-1.f4ae394d.svg";